import {ActionTypes} from "./topUpTemplate.types";

const INITIAL_STATE = {
  topUpTemplates: undefined
};

const topUpTemplateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_TOP_UP_TEMPLATES:
      return {
        ...state,
        topUpTemplates: action.payload,
      };
    default:
      return state;
  }
};

export default topUpTemplateReducer